module.exports = __webpack_public_path__ + "static/media/Relaxation Meditation Songs Divine - Кольоров метелики.7dd4ed55.mp3";